import LayoutSettings from '@/components/LayoutSetting/LayoutSettings';
import { DateChoicesEnum } from '@/constants/enum';
import {
  deliverySettingSelector,
  handleSaveDeliverySettings
} from '@/redux/slice/delivery.slice';
import { BlockStack, ChoiceList } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const DeliveryChoice = () => {
  const { t } = useTranslation('deliverySettings');
  const dispatch = useDispatch();
  const deliverySettings = useSelector(deliverySettingSelector);

  const deliveryChoices = [
    {
      label: t('sections.deliveryChoice.singleDate.title'),
      value: DateChoicesEnum.SINGLEDATE,
      helpText: t('sections.deliveryChoice.singleDate.helpText'),
    },
    {
      label: t('sections.deliveryChoice.exactTime.title'),
      value: DateChoicesEnum.DATETIME,
      helpText: t('sections.deliveryChoice.exactTime.helpText'),
    },
    {
      label: t('sections.deliveryChoice.timeRange.title'),
      value: DateChoicesEnum.DATETIMESLOT,
      helpText: t('sections.deliveryChoice.timeRange.helpText'),
    },
  ];

  const handleDeliveryChoice = (value: DateChoicesEnum) => {
    dispatch(handleSaveDeliverySettings({ deliveryChoice: value }));
  };

  return (
    <>
      <LayoutSettings title={t('sections.deliveryChoice.title')} helpText={t('sections.deliveryChoice.helpText')}>
        <BlockStack gap={'100'}>
          <ChoiceList
            name="deliveryChoice"
            title={t('sections.deliveryChoice.heading')}
            titleHidden
            choices={deliveryChoices}
            selected={[deliverySettings.deliveryChoice]}
            onChange={(value) => handleDeliveryChoice(value[0] as DateChoicesEnum)}
          />
        </BlockStack>
      </LayoutSettings>
    </>
  );
};

export default DeliveryChoice;
